import React from 'react';

export const HomeIcon = () => {
	return (
		<svg
			width='18'
			height='18'
			viewBox='0 0 18 18'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'>
			<g clipPath='url(#clip0_5798_9248)'>
				<rect
					width='18'
					height='18'
					fill='white'
					fillOpacity='0.01'
				/>
				<path
					d='M9.4002 1.29026C9.34795 1.23787 9.28588 1.19631 9.21754 1.16795C9.1492 1.1396 9.07594 1.125 9.00195 1.125C8.92797 1.125 8.8547 1.1396 8.78637 1.16795C8.71803 1.19631 8.65596 1.23787 8.6037 1.29026L1.8537 8.04026C1.8015 8.09259 1.76013 8.1547 1.73194 8.22303C1.70376 8.29137 1.68932 8.36459 1.68945 8.43851V16.3135C1.68945 16.4627 1.74872 16.6058 1.85421 16.7113C1.9597 16.8167 2.10277 16.876 2.25195 16.876H7.31445C7.46364 16.876 7.60671 16.8167 7.7122 16.7113C7.81769 16.6058 7.87695 16.4627 7.87695 16.3135V11.8135H10.127V16.3135C10.127 16.4627 10.1862 16.6058 10.2917 16.7113C10.3972 16.8167 10.5403 16.876 10.6895 16.876H15.752C15.9011 16.876 16.0442 16.8167 16.1497 16.7113C16.2552 16.6058 16.3145 16.4627 16.3145 16.3135V8.43851C16.3146 8.36459 16.3001 8.29137 16.272 8.22303C16.2438 8.1547 16.2024 8.09259 16.1502 8.04026L14.627 6.51813V2.81351C14.627 2.66432 14.5677 2.52125 14.4622 2.41576C14.3567 2.31027 14.2136 2.25101 14.0645 2.25101H12.9395C12.7903 2.25101 12.6472 2.31027 12.5417 2.41576C12.4362 2.52125 12.377 2.66432 12.377 2.81351V4.26813L9.4002 1.29026ZM2.81445 15.751V8.67138L9.00195 2.48388L15.1895 8.67138V15.751H11.252V11.251C11.252 11.1018 11.1927 10.9587 11.0872 10.8533C10.9817 10.7478 10.8386 10.6885 10.6895 10.6885H7.31445C7.16527 10.6885 7.0222 10.7478 6.91671 10.8533C6.81122 10.9587 6.75195 11.1018 6.75195 11.251V15.751H2.81445Z'
					fill='white'
				/>
			</g>
			<defs>
				<clipPath id='clip0_5798_9248'>
					<rect
						width='18'
						height='18'
						fill='white'
					/>
				</clipPath>
			</defs>
		</svg>
	);
};

export const DocumentsIcon = () => {
	return (
		<svg
			width='18'
			height='18'
			viewBox='0 0 18 18'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'>
			<g clipPath='url(#clip0_5798_9258)'>
				<rect
					width='18'
					height='18'
					fill='white'
					fillOpacity='0.01'
				/>
				<path
					d='M5.62695 4.50098C5.31629 4.50098 5.06445 4.75282 5.06445 5.06348C5.06445 5.37414 5.31629 5.62598 5.62695 5.62598H12.377C12.6876 5.62598 12.9395 5.37414 12.9395 5.06348C12.9395 4.75282 12.6876 4.50098 12.377 4.50098H5.62695Z'
					fill='white'
				/>
				<path
					d='M5.06445 7.31348C5.06445 7.00282 5.31629 6.75098 5.62695 6.75098H12.377C12.6876 6.75098 12.9395 7.00282 12.9395 7.31348C12.9395 7.62414 12.6876 7.87598 12.377 7.87598H5.62695C5.31629 7.87598 5.06445 7.62414 5.06445 7.31348Z'
					fill='white'
				/>
				<path
					d='M5.62695 9.00098C5.31629 9.00098 5.06445 9.25282 5.06445 9.56348C5.06445 9.87414 5.31629 10.126 5.62695 10.126H12.377C12.6876 10.126 12.9395 9.87414 12.9395 9.56348C12.9395 9.25282 12.6876 9.00098 12.377 9.00098H5.62695Z'
					fill='white'
				/>
				<path
					d='M5.62695 11.251C5.31629 11.251 5.06445 11.5028 5.06445 11.8135C5.06445 12.1241 5.31629 12.376 5.62695 12.376H9.00195C9.31261 12.376 9.56445 12.1241 9.56445 11.8135C9.56445 11.5028 9.31261 11.251 9.00195 11.251H5.62695Z'
					fill='white'
				/>
				<path
					d='M2.25195 2.25098C2.25195 1.00834 3.25931 0.000976562 4.50195 0.000976562H13.502C14.7446 0.000976562 15.752 1.00834 15.752 2.25098V15.751C15.752 16.9936 14.7446 18.001 13.502 18.001H4.50195C3.25931 18.001 2.25195 16.9936 2.25195 15.751V2.25098ZM13.502 1.12598H4.50195C3.88063 1.12598 3.37695 1.62966 3.37695 2.25098V15.751C3.37695 16.3723 3.88063 16.876 4.50195 16.876H13.502C14.1233 16.876 14.627 16.3723 14.627 15.751V2.25098C14.627 1.62966 14.1233 1.12598 13.502 1.12598Z'
					fill='white'
				/>
			</g>
			<defs>
				<clipPath id='clip0_5798_9258'>
					<rect
						width='18'
						height='18'
						fill='white'
					/>
				</clipPath>
			</defs>
		</svg>
	);
};

export const TaxPaymentsIcon = () => {
	return (
		<svg
			width='18'
			height='18'
			viewBox='0 0 18 18'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'>
			<g clipPath='url(#clip0_5798_9268)'>
				<rect
					width='18'
					height='18'
					fill='white'
					fillOpacity='0.01'
				/>
				<path
					d='M12.377 6.18848C12.377 6.03929 12.4362 5.89622 12.5417 5.79073C12.6472 5.68524 12.7903 5.62598 12.9395 5.62598H15.1895C15.3386 5.62598 15.4817 5.68524 15.5872 5.79073C15.6927 5.89622 15.752 6.03929 15.752 6.18848V7.31348C15.752 7.46266 15.6927 7.60573 15.5872 7.71122C15.4817 7.81671 15.3386 7.87598 15.1895 7.87598H12.9395C12.7903 7.87598 12.6472 7.81671 12.5417 7.71122C12.4362 7.60573 12.377 7.46266 12.377 7.31348V6.18848Z'
					fill='white'
				/>
				<path
					d='M2.25195 2.25098C1.65522 2.25098 1.08292 2.48803 0.660963 2.90999C0.239006 3.33194 0.00195313 3.90424 0.00195312 4.50098V13.501C0.00195313 14.0977 0.239006 14.67 0.660963 15.092C1.08292 15.5139 1.65522 15.751 2.25195 15.751H15.752C16.3487 15.751 16.921 15.5139 17.3429 15.092C17.7649 14.67 18.002 14.0977 18.002 13.501V4.50098C18.002 3.90424 17.7649 3.33194 17.3429 2.90999C16.921 2.48803 16.3487 2.25098 15.752 2.25098H2.25195ZM16.877 4.50098V10.126H1.12695V4.50098C1.12695 4.20261 1.24548 3.91646 1.45646 3.70548C1.66744 3.4945 1.95358 3.37598 2.25195 3.37598H15.752C16.0503 3.37598 16.3365 3.4945 16.5474 3.70548C16.7584 3.91646 16.877 4.20261 16.877 4.50098ZM15.752 14.626H2.25195C1.95358 14.626 1.66744 14.5075 1.45646 14.2965C1.24548 14.0855 1.12695 13.7993 1.12695 13.501V12.376H16.877V13.501C16.877 13.7993 16.7584 14.0855 16.5474 14.2965C16.3365 14.5075 16.0503 14.626 15.752 14.626Z'
					fill='white'
				/>
			</g>
			<defs>
				<clipPath id='clip0_5798_9268'>
					<rect
						width='18'
						height='18'
						fill='white'
					/>
				</clipPath>
			</defs>
		</svg>
	);
};

export const DistributeK1sIcon = () => {
	return (
		<svg
			width='18'
			height='18'
			viewBox='0 0 18 18'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'>
			<g clipPath='url(#clip0_5798_9278)'>
				<rect
					width='18'
					height='18'
					fill='white'
					fillOpacity='0.01'
				/>
				<path
					d='M13.2744 9.30585L9.6946 11.5221C9.39085 11.7089 9.0016 11.4816 9.0016 11.1036V10.2385C9.0016 10.2385 6.10923 9.90098 4.5016 12.9385C5.14398 7.53848 8.03748 7.53848 9.0016 7.53848V6.67335C9.0016 6.29535 9.39085 6.0681 9.6946 6.25598L13.2744 8.4711C13.5781 8.65785 13.5781 9.1191 13.2744 9.30585Z'
					fill='white'
				/>
				<path
					d='M0.564102 3.37598L0.609102 4.35473C0.312289 4.78622 0.176143 5.30811 0.224352 5.8296L0.940977 13.7046C0.991778 14.2636 1.24971 14.7835 1.66412 15.1621C2.07854 15.5407 2.61952 15.7508 3.18085 15.751H14.8224C15.3837 15.7508 15.9247 15.5407 16.3391 15.1621C16.7535 14.7835 17.0114 14.2636 17.0622 13.7046L17.7789 5.8296C17.8071 5.51822 17.7702 5.20437 17.6705 4.90805C17.5707 4.61173 17.4103 4.33946 17.1994 4.1086C16.9886 3.87774 16.7319 3.69336 16.4458 3.56722C16.1597 3.44108 15.8505 3.37594 15.5379 3.37598H11.0581C10.4614 3.37585 9.88921 3.13871 9.46735 2.71673L8.53585 1.78523C8.11399 1.36324 7.54179 1.1261 6.9451 1.12598H2.8141C2.21737 1.12598 1.64507 1.36303 1.22311 1.78499C0.801155 2.20694 0.564102 2.77924 0.564102 3.37598ZM1.34485 5.72723C1.33079 5.57158 1.3493 5.41471 1.39922 5.26662C1.44914 5.11853 1.52937 4.98247 1.63479 4.8671C1.74021 4.75173 1.86851 4.65959 2.01151 4.59655C2.15451 4.53352 2.30907 4.50097 2.46535 4.50098H15.5379C15.6941 4.50097 15.8487 4.53352 15.9917 4.59655C16.1347 4.65959 16.263 4.75173 16.3684 4.8671C16.4738 4.98247 16.5541 5.11853 16.604 5.26662C16.6539 5.41471 16.6724 5.57158 16.6584 5.72723L15.9429 13.6022C15.9176 13.8819 15.7886 14.1421 15.5812 14.3315C15.3739 14.521 15.1032 14.626 14.8224 14.626H3.18085C2.90019 14.6257 2.62977 14.5206 2.42267 14.3311C2.21556 14.1417 2.08674 13.8817 2.06148 13.6022L1.34485 5.72723ZM6.9451 2.25098C7.24345 2.25104 7.52955 2.36961 7.74048 2.5806L8.53585 3.37598H2.46535C2.19535 3.37598 1.9366 3.42323 1.69698 3.51098L1.6891 3.35348C1.69499 3.05902 1.81611 2.77862 2.02646 2.57249C2.2368 2.36635 2.51959 2.25092 2.8141 2.25098H6.9451Z'
					fill='white'
				/>
			</g>
			<defs>
				<clipPath id='clip0_5798_9278'>
					<rect
						width='18'
						height='18'
						fill='white'
					/>
				</clipPath>
			</defs>
		</svg>
	);
};

export const SecuritySettingsIcon = () => {
	return (
		<svg
			width='18'
			height='18'
			viewBox='0 0 18 18'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'>
			<g clipPath='url(#clip0_5798_9288)'>
				<rect
					width='18'
					height='18'
					fill='white'
					fillOpacity='0.01'
				/>
				<path
					d='M9.00139 5.34915C8.52184 5.34915 8.04698 5.44361 7.60393 5.62713C7.16088 5.81064 6.75831 6.07963 6.41921 6.41873C6.08012 6.75782 5.81113 7.16039 5.62761 7.60344C5.4441 8.04649 5.34964 8.52135 5.34964 9.0009C5.34964 9.48046 5.4441 9.95532 5.62761 10.3984C5.81113 10.8414 6.08012 11.244 6.41921 11.5831C6.75831 11.9222 7.16088 12.1912 7.60393 12.3747C8.04698 12.5582 8.52184 12.6527 9.00139 12.6527C9.96989 12.6527 10.8987 12.2679 11.5836 11.5831C12.2684 10.8982 12.6531 9.96941 12.6531 9.0009C12.6531 8.0324 12.2684 7.10356 11.5836 6.41873C10.8987 5.73389 9.96989 5.34915 9.00139 5.34915ZM6.47464 9.0009C6.47464 8.33077 6.74085 7.68808 7.21471 7.21422C7.68857 6.74036 8.33125 6.47415 9.00139 6.47415C9.67153 6.47415 10.3142 6.74036 10.7881 7.21422C11.2619 7.68808 11.5281 8.33077 11.5281 9.0009C11.5281 9.67104 11.2619 10.3137 10.7881 10.7876C10.3142 11.2614 9.67153 11.5277 9.00139 11.5277C8.33125 11.5277 7.68857 11.2614 7.21471 10.7876C6.74085 10.3137 6.47464 9.67104 6.47464 9.0009Z'
					fill='white'
				/>
				<path
					d='M11.0219 1.51178C10.429 -0.501973 7.57377 -0.501973 6.98089 1.51178L6.87514 1.87065C6.83374 2.01122 6.7614 2.14075 6.66343 2.24973C6.56547 2.35871 6.44436 2.44439 6.30897 2.50049C6.17359 2.55658 6.02738 2.58167 5.88104 2.57391C5.7347 2.56615 5.59196 2.52575 5.46327 2.45565L5.13477 2.27565C3.28977 1.27215 1.27264 3.2904 2.27727 5.13428L2.45614 5.46278C2.52623 5.59147 2.56664 5.73421 2.5744 5.88055C2.58216 6.02689 2.55707 6.17311 2.50097 6.30849C2.44488 6.44387 2.3592 6.56498 2.25022 6.66295C2.14124 6.76091 2.01171 6.83325 1.87114 6.87465L1.51227 6.9804C-0.501484 7.57328 -0.501484 10.4285 1.51227 11.0214L1.87114 11.1272C2.01171 11.1686 2.14124 11.2409 2.25022 11.3389C2.3592 11.4368 2.44488 11.5579 2.50097 11.6933C2.55707 11.8287 2.58216 11.9749 2.5744 12.1213C2.56664 12.2676 2.52623 12.4103 2.45614 12.539L2.27614 12.8675C1.27264 14.7125 3.28977 16.7308 5.13477 15.725L5.46327 15.5462C5.59196 15.4761 5.7347 15.4357 5.88104 15.4279C6.02738 15.4201 6.17359 15.4452 6.30897 15.5013C6.44436 15.5574 6.56547 15.6431 6.66343 15.7521C6.7614 15.8611 6.83374 15.9906 6.87514 16.1312L6.98089 16.49C7.57377 18.5038 10.429 18.5038 11.0219 16.49L11.1276 16.1312C11.169 15.9906 11.2414 15.8611 11.3393 15.7521C11.4373 15.6431 11.5584 15.5574 11.6938 15.5013C11.8292 15.4452 11.9754 15.4201 12.1217 15.4279C12.2681 15.4357 12.4108 15.4761 12.5395 15.5462L12.868 15.7262C14.713 16.7308 16.7313 14.7114 15.7255 12.8675L15.5466 12.539C15.4765 12.4103 15.4361 12.2676 15.4284 12.1213C15.4206 11.9749 15.4457 11.8287 15.5018 11.6933C15.5579 11.5579 15.6436 11.4368 15.7526 11.3389C15.8615 11.2409 15.9911 11.1686 16.1316 11.1272L16.4905 11.0214C18.5043 10.4285 18.5043 7.57328 16.4905 6.9804L16.1316 6.87465C15.9911 6.83325 15.8615 6.76091 15.7526 6.66295C15.6436 6.56498 15.5579 6.44387 15.5018 6.30849C15.4457 6.17311 15.4206 6.02689 15.4284 5.88055C15.4361 5.73421 15.4765 5.59147 15.5466 5.46278L15.7266 5.13428C16.7313 3.28928 14.7119 1.27215 12.868 2.27678L12.5395 2.45565C12.4108 2.52575 12.2681 2.56615 12.1217 2.57391C11.9754 2.58167 11.8292 2.55658 11.6938 2.50049C11.5584 2.44439 11.4373 2.35871 11.3393 2.24973C11.2414 2.14075 11.169 2.01122 11.1276 1.87065L11.0219 1.51178ZM8.05977 1.83015C8.33652 0.890777 9.66627 0.890777 9.94302 1.83015L10.0488 2.18903C10.1377 2.49062 10.2929 2.7685 10.5032 3.00229C10.7134 3.23608 10.9733 3.41985 11.2639 3.54013C11.5544 3.66041 11.8681 3.71415 12.1821 3.69742C12.4961 3.68068 12.8023 3.59389 13.0784 3.4434L13.4058 3.2634C14.2653 2.79653 15.2058 3.7359 14.7378 4.59653L14.5589 4.92503C14.4086 5.20113 14.3221 5.50736 14.3055 5.82126C14.2889 6.13517 14.3428 6.44881 14.4632 6.73918C14.5836 7.02956 14.7674 7.28933 15.0012 7.49945C15.235 7.70957 15.5129 7.86472 15.8144 7.95353L16.1721 8.05928C17.1115 8.33603 17.1115 9.66578 16.1721 9.94253L15.8133 10.0483C15.5117 10.1372 15.2338 10.2924 15 10.5027C14.7662 10.7129 14.5824 10.9729 14.4622 11.2634C14.3419 11.5539 14.2881 11.8676 14.3049 12.1816C14.3216 12.4956 14.4084 12.8018 14.5589 13.0779L14.7389 13.4053C15.2058 14.2648 14.2664 15.2053 13.4058 14.7373L13.0784 14.5584C12.8022 14.4079 12.4959 14.3212 12.1819 14.3045C11.8678 14.2879 11.554 14.3417 11.2635 14.4621C10.973 14.5825 10.7131 14.7664 10.5029 15.0003C10.2927 15.2342 10.1375 15.5122 10.0488 15.8139L9.94302 16.1717C9.66627 17.111 8.33652 17.111 8.05977 16.1717L7.95402 15.8128C7.86508 15.5113 7.70984 15.2336 7.49966 14.9999C7.28949 14.7663 7.02971 14.5826 6.73934 14.4623C6.44898 14.342 6.13539 14.2883 5.82154 14.3049C5.5077 14.3215 5.20155 14.4081 4.92552 14.5584L4.59702 14.7384C3.73752 15.2053 2.79702 14.2659 3.26502 13.4053L3.44389 13.0779C3.59459 12.8018 3.68155 12.4954 3.6984 12.1813C3.71524 11.8672 3.66155 11.5533 3.54125 11.2626C3.42096 10.972 3.23711 10.712 3.0032 10.5016C2.7693 10.2913 2.49127 10.136 2.18952 10.0472L1.83064 9.9414C0.891266 9.66465 0.891266 8.3349 1.83064 8.05815L2.18952 7.9524C2.4908 7.86343 2.76837 7.70821 3.00193 7.49811C3.23548 7.28802 3.4191 7.02836 3.53935 6.73814C3.6596 6.44792 3.71344 6.13449 3.69692 5.82077C3.6804 5.50706 3.59395 5.20101 3.44389 4.92503L3.26389 4.59653C2.79702 3.73703 3.73639 2.79653 4.59702 3.26453L4.92552 3.4434C5.20155 3.59367 5.5077 3.6803 5.82154 3.69692C6.13539 3.71355 6.44898 3.65976 6.73934 3.5395C7.02971 3.41923 7.28949 3.23553 7.49966 3.00186C7.70984 2.76819 7.86508 2.49047 7.95402 2.18903L8.05977 1.83015Z'
					fill='white'
				/>
			</g>
			<defs>
				<clipPath id='clip0_5798_9288'>
					<rect
						width='18'
						height='18'
						fill='white'
					/>
				</clipPath>
			</defs>
		</svg>
	);
};

export const LogoutIcon = () => {
	return (
		<svg
			width='18'
			height='18'
			viewBox='0 0 18 18'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'>
			<g clipPath='url(#clip0_5798_7201)'>
				<rect
					width='18'
					height='18'
					fill='white'
					fillOpacity='0.01'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M7.31445 14.6262C7.00379 14.6262 6.75195 14.3744 6.75195 14.0637L6.75195 11.8137C6.75195 11.5031 6.50011 11.2512 6.18945 11.2512C5.87879 11.2512 5.62695 11.5031 5.62695 11.8137V14.0637C5.62695 14.9957 6.38247 15.7512 7.31445 15.7512H16.3145C17.2464 15.7512 18.002 14.9957 18.002 14.0637L18.002 3.93872C18.002 3.00674 17.2464 2.25122 16.3145 2.25122L7.31445 2.25122C6.38247 2.25122 5.62695 3.00674 5.62695 3.93872V6.18872C5.62695 6.49938 5.87879 6.75122 6.18945 6.75122C6.50011 6.75122 6.75195 6.49938 6.75195 6.18872V3.93872C6.75195 3.62806 7.00379 3.37622 7.31445 3.37622L16.3145 3.37622C16.6251 3.37622 16.877 3.62806 16.877 3.93872L16.877 14.0637C16.877 14.3744 16.6251 14.6262 16.3145 14.6262H7.31445ZM0.166706 8.60347C-0.0529644 8.82314 -0.0529644 9.1793 0.166706 9.39897L3.54171 12.774C3.76138 12.9936 4.11753 12.9936 4.3372 12.774C4.55687 12.5543 4.55687 12.1981 4.3372 11.9785L1.92245 9.56372L11.8145 9.56372C12.1251 9.56372 12.377 9.31188 12.377 9.00122C12.377 8.69056 12.1251 8.43872 11.8145 8.43872L1.92245 8.43872L4.3372 6.02397C4.55687 5.8043 4.55687 5.44814 4.3372 5.22847C4.11753 5.0088 3.76138 5.0088 3.54171 5.22847L0.166706 8.60347Z'
					fill='white'
				/>
			</g>
			<defs>
				<clipPath id='clip0_5798_7201'>
					<rect
						width='18'
						height='18'
						fill='white'
					/>
				</clipPath>
			</defs>
		</svg>
	);
};
export const LeftArrowIcon = () => {
	return (
		<svg
			width='16'
			height='16'
			viewBox='0 0 16 16'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M8.35392 1.64592C8.40048 1.69236 8.43742 1.74754 8.46263 1.80828C8.48784 1.86903 8.50081 1.93415 8.50081 1.99992C8.50081 2.06568 8.48784 2.13081 8.46263 2.19155C8.43742 2.2523 8.40048 2.30747 8.35392 2.35392L2.70692 7.99992L8.35392 13.6459C8.4478 13.7398 8.50055 13.8671 8.50055 13.9999C8.50055 14.1327 8.4478 14.26 8.35392 14.3539C8.26003 14.4478 8.13269 14.5005 7.99992 14.5005C7.86714 14.5005 7.7398 14.4478 7.64592 14.3539L1.64592 8.35392C1.59935 8.30747 1.56241 8.2523 1.5372 8.19155C1.512 8.13081 1.49902 8.06568 1.49902 7.99992C1.49902 7.93415 1.512 7.86903 1.5372 7.80828C1.56241 7.74754 1.59935 7.69236 1.64592 7.64592L7.64592 1.64592C7.69236 1.59935 7.74754 1.56241 7.80828 1.5372C7.86903 1.512 7.93415 1.49902 7.99992 1.49902C8.06568 1.49902 8.13081 1.512 8.19155 1.5372C8.2523 1.56241 8.30747 1.59935 8.35392 1.64592Z'
				fill='#88C656'
			/>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M12.3539 1.64592C12.4005 1.69236 12.4374 1.74754 12.4626 1.80828C12.4878 1.86903 12.5008 1.93415 12.5008 1.99992C12.5008 2.06568 12.4878 2.13081 12.4626 2.19155C12.4374 2.2523 12.4005 2.30747 12.3539 2.35392L6.70692 7.99992L12.3539 13.6459C12.4004 13.6924 12.4373 13.7476 12.4624 13.8083C12.4876 13.8691 12.5005 13.9342 12.5005 13.9999C12.5005 14.0657 12.4876 14.1308 12.4624 14.1915C12.4373 14.2522 12.4004 14.3074 12.3539 14.3539C12.3074 14.4004 12.2522 14.4373 12.1915 14.4624C12.1308 14.4876 12.0657 14.5005 11.9999 14.5005C11.9342 14.5005 11.8691 14.4876 11.8083 14.4624C11.7476 14.4373 11.6924 14.4004 11.6459 14.3539L5.64592 8.35392C5.59935 8.30747 5.56241 8.2523 5.5372 8.19155C5.512 8.13081 5.49902 8.06568 5.49902 7.99992C5.49902 7.93415 5.512 7.86903 5.5372 7.80828C5.56241 7.74754 5.59935 7.69236 5.64592 7.64592L11.6459 1.64592C11.6924 1.59935 11.7475 1.56241 11.8083 1.5372C11.869 1.512 11.9341 1.49902 11.9999 1.49902C12.0657 1.49902 12.1308 1.512 12.1916 1.5372C12.2523 1.56241 12.3075 1.59935 12.3539 1.64592Z'
				fill='#88C656'
			/>
		</svg>
	);
};

export const RightArrowIcon = () => {
	return (
		<svg
			width='16'
			height='16'
			viewBox='0 0 16 16'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M7.64608 14.3541C7.59952 14.3076 7.56258 14.2525 7.53737 14.1917C7.51216 14.131 7.49919 14.0658 7.49919 14.0001C7.49919 13.9343 7.51216 13.8692 7.53737 13.8084C7.56258 13.7477 7.59952 13.6925 7.64608 13.6461L13.2931 8.00008L7.64608 2.35408C7.5522 2.2602 7.49945 2.13286 7.49945 2.00008C7.49945 1.86731 7.5522 1.73997 7.64608 1.64608C7.73997 1.5522 7.86731 1.49945 8.00008 1.49945C8.13286 1.49945 8.2602 1.5522 8.35408 1.64608L14.3541 7.64608C14.4006 7.69253 14.4376 7.7477 14.4628 7.80845C14.488 7.86919 14.501 7.93432 14.501 8.00008C14.501 8.06585 14.488 8.13097 14.4628 8.19172C14.4376 8.25246 14.4006 8.30764 14.3541 8.35408L8.35408 14.3541C8.30764 14.4006 8.25246 14.4376 8.19172 14.4628C8.13097 14.488 8.06585 14.501 8.00008 14.501C7.93432 14.501 7.86919 14.488 7.80845 14.4628C7.7477 14.4376 7.69253 14.4006 7.64608 14.3541Z'
				fill='#88C656'
			/>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M3.64608 14.3541C3.59952 14.3076 3.56258 14.2525 3.53737 14.1917C3.51216 14.131 3.49919 14.0658 3.49919 14.0001C3.49919 13.9343 3.51216 13.8692 3.53737 13.8084C3.56258 13.7477 3.59952 13.6925 3.64608 13.6461L9.29308 8.00008L3.64608 2.35408C3.5996 2.30759 3.56272 2.25241 3.53756 2.19167C3.5124 2.13093 3.49945 2.06583 3.49945 2.00008C3.49945 1.93434 3.5124 1.86924 3.53756 1.8085C3.56272 1.74776 3.5996 1.69257 3.64608 1.64608C3.69257 1.59959 3.74776 1.56272 3.8085 1.53756C3.86924 1.5124 3.93434 1.49945 4.00008 1.49945C4.06583 1.49945 4.13093 1.5124 4.19167 1.53756C4.25241 1.56272 4.3076 1.59959 4.35408 1.64608L10.3541 7.64608C10.4006 7.69253 10.4376 7.7477 10.4628 7.80845C10.488 7.86919 10.501 7.93432 10.501 8.00008C10.501 8.06585 10.488 8.13097 10.4628 8.19172C10.4376 8.25246 10.4006 8.30764 10.3541 8.35408L4.35408 14.3541C4.30764 14.4006 4.25246 14.4376 4.19172 14.4628C4.13097 14.488 4.06585 14.501 4.00008 14.501C3.93432 14.501 3.86919 14.488 3.80845 14.4628C3.7477 14.4376 3.69253 14.4006 3.64608 14.3541Z'
				fill='#88C656'
			/>
		</svg>
	);
};
